import { render, staticRenderFns } from "./pm-app-component.vue?vue&type=template&id=3dd33b7e&"
import script from "./pm-app-component.vue?vue&type=script&lang=js&"
export * from "./pm-app-component.vue?vue&type=script&lang=js&"
import style0 from "./pm-app-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports